import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5a8d3397")
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/29.png",
  alt: "png"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("figure", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, "Jumping Forward..."))
    ])
  ]))
}